import { render, staticRenderFns } from "./SettingsManager.vue?vue&type=template&id=1b32acac&scoped=true"
import script from "./SettingsManager.vue?vue&type=script&lang=js"
export * from "./SettingsManager.vue?vue&type=script&lang=js"
import style0 from "./SettingsManager.vue?vue&type=style&index=0&id=1b32acac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32acac",
  null
  
)

export default component.exports